import { BehaviorSubject } from 'rxjs';

const ErrorModalSubject = new BehaviorSubject(false);

const ErrorModalStore = {
  update: value => {
    ErrorModalSubject.next(value);
  },
  subscribe: setState => ErrorModalSubject.subscribe(setState),
  getValue: () => ErrorModalSubject.value,
};

export { ErrorModalStore };
